<template>
    <div class="user">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>用户列表</h2>
            </div>
        </div>
        <div class="page-content">
            <div class="table">
                <el-form :inline="true" class="demo-form-inline"  size="mini" style="text-align: left">
                    <el-form-item label="用户手机号">
                        <el-input v-model="mobile" maxlength="11" placeholder="请输入用户手机号" clearable @clear="searchList()"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchList">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                                v-model="value2"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="uploadList">导出</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="tableData"
                        v-loading="loading"
                        border
                        size="mini"
                        style="width: 100%">
                    <el-table-column
                            prop="user_name"
                            label="用户名"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop=""
                            align="center"
                            label="头像"
                            width="100">
                        <template slot-scope="scope">
                            <img style="width: 80px;height: 80px;border-radius: 8px" :src="scope.row.avatar|handleImg" alt="">
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="手机号"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="city"
                            label="所属城市"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="referrer_name"
                            align="center"
                            label="推荐人姓名">
                    </el-table-column>
                    <el-table-column
                            prop="referrer_mobile"
                            align="center"
                            label="推荐人电话">
                    </el-table-column>
                    <el-table-column
                            prop="space_num"
                            align="center"
                            label="场地数量"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="service_num"
                            align="center"
                            label="服务商数量"
                            width="60">
                    </el-table-column>
                    <el-table-column
                            prop="total_amount"
                            align="center"
                            label="总佣金">
                        <template slot-scope="scope">
                            <span>{{scope.row.total_amount}}元</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cash_amount"
                            align="center"
                            label="已提现佣金">
                        <template slot-scope="scope">
                            <span>{{scope.row.cash_amount}}元</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="balance"
                            align="center"
                            label="余额">
                        <template slot-scope="scope">
                            <span>{{scope.row.balance}}元</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="create_time"
                            align="center"
                            label="创建时间">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status<=1&&(role!=4||(role==4&&hasLimit))" type="text" size="small" @click="djRow(scope.row)">冻结</el-button>
                            <el-button v-if="scope.row.status==8&&(role!=4||(role==4&&hasLimit))" type="text" size="small" @click="jdRow(scope.row)">解冻</el-button>
                            <el-button v-if="role!=4||(role==4&&hasDel)" type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
                            <el-button type="text" size="small" @click="detail(scope.row)" v-if="role==1">收益详情</el-button>
                            <el-button v-if="role==1||(role==4&&hasUpdate)" type="text" size="small" @click="update(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
 :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog title="用户收益详情" :visible.sync="detailPop">
            <el-form :inline="true" class="demo-form-inline"  size="mini" style="text-align: left">
                <el-form-item>
                    <el-date-picker
                            v-model="value1"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="uploadRecord">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="detailData"
                v-loading="loading"
                border
                size="mini">
                <el-table-column prop="create_time" align="center" label="日期" width="150"></el-table-column>
                <el-table-column prop="type" align="center" label="变动来源" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">收入</span>
                        <span v-if="scope.row.type==2">提现</span>
                    </template>
                </el-table-column>
                <el-table-column prop="money" align="center" label="变动金额"></el-table-column>
                <el-table-column prop="balance" align="center" label="结余金额"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
<!--                <el-button type="primary" @click="uploadFile">导 出</el-button>-->
            </span>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="mpages"
                    :current-page="mpage"
                    @current-change="detailChange"
                    style="margin-top: 20px; text-align: right;"
            >
            </el-pagination>
        </el-dialog>
        <el-dialog title="用户信息修改" width="400px" :visible.sync="updatePop">
            <el-form ref="form"  :model="form" label-width="120px">
                <el-form-item label="注册时间" prop="mobile">
                    <el-input v-model="updateData.create_time" maxlength="11" disabled="true" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item label="注册IP" prop="mobile">
                    <el-input v-model="updateData.first_ip" maxlength="11" disabled="true" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item label="最后登录时间" prop="mobile">
                    <el-input v-model="updateData.last_time" maxlength="11" disabled="true" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item label="最后登录IP" prop="mobile">
                    <el-input v-model="updateData.last_ip" maxlength="11" disabled="true" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item label="登录次数" prop="mobile">
                    <el-input v-model="updateData.login_num" maxlength="11" disabled="true" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item label="用户原手机号" prop="mobile">
                    <el-input v-model="updateData.mobile" maxlength="11" disabled="true" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item label="用户新手机号" prop="mobile">
                    <el-input v-model="form.mobile" maxlength="11" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item label="用户密码" prop="password">
                    <el-input v-model="form.password" auto-complete="false" type="password"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelUpdate">取 消</el-button>
                <el-button type="primary" @click="surUpdate">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {userList,updateUserData,updateUserInfo} from '../../api/index'
    import {seeFinancial} from '../../api/role'
    import {mapState} from "vuex";
    export default {
        name: "user",
        data() {
            return {
                role:0,
                tableData: [],
                pages:1,
                page:1,
                loading:true,
                detailPop:false,
                detailData:[],
                mobile:'',
                updatePop:false,//用户信息修改弹窗
                updateData:'',//需修改的用户信息
                form:{
                    mobile:'',
                    password:'',
                },
                mpage:1,
                mpages:1,
                role_ads:[],
                hasDel:false,
                hasUpdate:false,
                hasLimit:false,
                uid:'',
                token:'',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value2: '',
                value1:'',
                uid:'',
            }
        },
        computed:{
            ...mapState(['baseUrl'])
        },
        mounted(){
            this.getUserList();
            this.role=localStorage.getItem('ROLE');
            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            this.role_ads=JSON.parse(localStorage.getItem('USERINFO')).role_adm_access_ids;
            if(this.role_ads.length>0){
                this.hasUpdate= this.role_ads.includes('29');
                this.hasDel= this.role_ads.includes('30');
                this.hasLimit= this.role_ads.includes('31');
            }
           this.token= window.localStorage.getItem('UTOKEN');
        },
        methods:{
            searchList(){
              this.page=1;
              this.getUserList();
            },
            getUserList(){
                this.loading=true;
                userList({
                    p:this.page,
                    mobile:this.mobile
                }).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.tableData=res.data.list;
                        this.pages=res.data.total_num;
                    }
                })
            },
            handleCurrentChange(val){
                this.page = val;
                this.getUserList()
            },
            djRow(row){
                this.$confirm('确认要冻结此用户吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateUserData({uid:row.uid,status:8}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '冻结成功!'
                            });
                            this.getUserList();
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                })
            },
            jdRow(row){
                this.$confirm('确认要解冻此用户吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateUserData({uid:row.uid,status:1}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '解冻成功!'
                            });
                            this.getUserList();
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                })
            },
            deleteRow(row){
                this.$confirm('确认要删除此用户吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateUserData({uid:row.uid,status:9}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getUserList();
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                })
            },
            detail(row){
                this.detailData=[];
                this.uid=row.uid;
                this.getMoneyDetail(row.uid);
                this.detailPop=true;
            },
            getMoneyDetail(uid){
                seeFinancial({
                    p:this.mpage,
                    utype:2,
                    uid:uid
                }).then(res=>{
                    if(res.code==1){
                        this.detailData=res.data.list;
                        this.mpages=res.data.total_num;
                    }
                })
            },
            detailChange(val){
                this.mpage = val;
                this.getMoneyDetail()
            },
            update(row){
                this.updateData=row;
                this.updatePop=true;
            },
            cancelUpdate(){
                this.updateData='';
                this.updatePop=false;
            },
            surUpdate(){
                if(!/^[1][0-9]{10}$/.test(this.form.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                if(!this.form.password||this.form.password.length<6){
                    this.$message.error('请输入密码且密码不能小于6位');
                    return;
                }
                this.form.uid=this.updateData.uid;
                updateUserInfo(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.updatePop=false;
                        this.getUserList();
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            uploadList(){
                console.log(this.value2);
                if(!this.value2){
                    this.$message.error('请选择下载周期');
                    return;
                }
                window.location.href="https://cdb.0731app.cn/home/user/export?token="+this.token+'&stime='+this.value2[0]+'&etime='+this.value2[1];
            },
            uploadRecord(){
                console.log(this.value1);
                if(!this.value1){
                    this.$message.error('请选择下载周期');
                    return;
                }
                window.location.href="https://cdb.0731app.cn/home/user/export?token="+this.token+'&uid=='+this.uid+'&stime='+this.value1[0]+'&etime='+this.value1[1];
            },
        }
    }
</script>

<style lang="scss" scoped>
.page-content{
    padding: 20px;
    .table{
        background-color: #fff;
        padding: 20px;
        box-shadow: 0 4px 4px 0 #e1e5eb;
    }
}
</style>
